import React, { Component } from "react";
import { Row, Col, Card, Badge, Tooltip, message, Typography, Radio, Form, Space } from "antd";
import cloneDeep from 'lodash/cloneDeep';
import sortBy from 'lodash/sortBy';
import moment from 'moment';
import { ReButton, ReModal } from "@/components/refineElement";
import { getOnOkFunction, showCheckConfirm } from "@/lib/antdElementFunction";
import {
  translateDay,
  announcementTime,
  dateFormat,
  dateTimeFormat3,
  convertToTimestamp10,
  convertToTimestamp,
  getDayVacationDateParams,
  getDayMakeUpDateParams,
  startThisMonth,
  endThisMonth,
  getMoment,
  timeHrMin,
} from "@/lib/dateTime";
import Leave from "@/config/leave";
import Student from "@/config/student";
import RollCallonfig from "@/config/rollCall";
import { getStorage } from "@/lib/webStorage";
import { getLangList } from '@/lib/i18n';
import { hasPermission } from "@/lib/permissionUtil";
import ModalLeave from "./modalLeave";
import "./index.less";

const { getLeaveInfo, deleteLeaveInfo, updateLeaveInfo, createLeaveInfo } = Leave;
const { getAllStudent, getTimePeriod } = Student;
const { getVacationAndMakeUpDay } = RollCallonfig;
const { Text } = Typography;

interface state {
  isModalVisible: boolean;
  weekPoint: number;
  handleType: string;
  startTime: any;
  endTime: any;
  weekLeaveObject: object;
  leaveInfo: any;
  allStudent: any;
  intervalArray: any;
  specialDateArray: any;
}

class LeaveSystem extends Component<{}, state> {
  state = {
    isModalVisible: false,
    weekPoint: 0,
    handleType: '',
    startTime: moment().startOf('week').valueOf(),
    endTime: moment().endOf('week').valueOf(),
    weekLeaveObject: { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] } as never as any,
    leaveInfo: {} as never as any,
    allStudent: [],
    intervalArray: [],
    specialDateArray: [],
  };
  leaveT: any = getLangList("leave");
  errorT: any = getLangList("error");
  buttonT: any = getLangList("button");
  dateArray: Array<string> = [];
  formRef: any = React.createRef();

  componentDidMount() {
    this.getLeaveInfo();
    this.getAllStudent();
    this.getTimePeriodFunction();
    this.getVacationAndMakeUpDay();
  }

  getLeaveInfo = () => {
    const { startTime, endTime } = this.state;
    const params = { startTime, endTime };

    this.getDateArray();
    getLeaveInfo(params).then((res: any) => {
      const levelArray = res?.value ?? [];
      const weekLeaveObject = this.getWeekLeavlObject(levelArray);
      this.setState({ weekLeaveObject });
    });
  }

  getAllStudent = () => {
    getAllStudent().then((res: any) => {
      const allStudent = res?.value ?? [];
      this.setState({ allStudent });
    });
  }

  getVacationAndMakeUpDay = () => {
    const params = { startTime: convertToTimestamp(startThisMonth), endTime: convertToTimestamp(endThisMonth) };

    getVacationAndMakeUpDay(params).then((res: any) => {
      const specialDateArray = res?.value ?? [];

      this.setState({ specialDateArray });
    });
  }

  getWeekLeavlObject = (levelArray: any) => {
    let weekLeaveObject: object = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] };
    levelArray.forEach((level: any) => {
      weekLeaveObject = this.assignLeaveToWeekLeavlObject(level, weekLeaveObject);
    });
    return weekLeaveObject;
  }

  getTimePeriodFunction = () => {
    getTimePeriod().then((res: any) => {
      const intervalArray = res?.value ?? [];
      this.setState({ intervalArray });
    });
  };

  assignLeaveToWeekLeavlObject = (level: any, weekLeaveObject: any) => {
    const { startTime, endTime } = level ?? {};
    const start = moment(startTime);
    const end = moment(endTime);
    const newWeekLeavlObject: any = cloneDeep(weekLeaveObject);

    for (let a = 0; a < this.dateArray.length; a++) {
      const toDay = this.dateArray[a];
      const isTodayInRange = moment(toDay, dateFormat).isBetween(start, end);
      const isSameDay = toDay === start.format(dateFormat) || toDay === end.format(dateFormat)

      if (isTodayInRange || isSameDay) {
        newWeekLeavlObject[a].push(level);
      }
    }
    return newWeekLeavlObject;
  }

  toggleModal = (handleType: string = '') => {
    const { isModalVisible } = this.state;
    this.setState({ isModalVisible: !isModalVisible, handleType });
  }

  clickEdit = (data: object) => {
    this.setState({ leaveInfo: data }, () => this.toggleModal('update'));
  }

  clickCreate = () => {
    this.setState({ leaveInfo: {} }, () => this.toggleModal('create'));
  }

  getDateArray = () => {
    const { weekPoint } = this.state;
    this.dateArray = [];

    for (let a = 0; a <= 6; a += 1) {
      const week = moment().add(weekPoint, 'weeks').startOf('week');
      const date = week.add(a, 'days').format(dateFormat);
      this.dateArray.push(date);
    }
  }

  changeWeekPoint = (value: number) => {
    const { weekPoint } = this.state;
    const newWeekPoint = weekPoint + value;
    const startTime = moment().add(newWeekPoint, 'weeks').startOf('week').valueOf();
    const endTime = moment().add(newWeekPoint, 'weeks').endOf('week').valueOf();

    this.setState({ weekPoint: newWeekPoint, startTime, endTime }, () => {
      this.getLeaveInfo();
    });
  }

  clickDelete = (data: any) => (e: any) => {
    e.stopPropagation();
    showCheckConfirm(
      () => this.deleteLeaveInfo(data),
      this.buttonT,
      this.buttonT.confirm_delete,
      (
        <Form ref={this.formRef} style={{ marginTop: '20px' }} initialValues={{ deleteType: 1 }}>
          <Form.Item name="deleteType">
            <Radio.Group>
              <Space direction="vertical">
                <Radio value={1}>{this.leaveT.DELETE_OPTION_1}</Radio>
                <Radio value={2}>{this.leaveT.DELETE_OPTION_2}</Radio>
                <Radio value={3}>{this.leaveT.DELETE_OPTION_3}</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Form >
      ),
    );
  };

  deleteLeaveInfo = (data: any) => {
    const { leaveId, parentLeaveId } = data;
    const params = {
      leaveId,
      parentId: parentLeaveId,
      deleteType: this.formRef.current.getFieldValue('deleteType'),
    };

    deleteLeaveInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.getLeaveInfo();
    });
  }

  createLeaveInfo = (values: any) => {
    const {
      date,
      leaveType,
      leaveDescription,
      userAccountId,
      recurrenceDays,
      recurrenceType,
      recurrenceEndDate,
    } = values;
    const isRecurring = recurrenceDays.length > 0;
    const recurrenceTypeValue = isRecurring ? recurrenceType : null;
    const params = {
      startTime: convertToTimestamp10(date[0]),
      endTime: convertToTimestamp10(date[1]),
      leaveType,
      userAccountId: userAccountId ? userAccountId : getStorage("userAccountId"),
      leaveDescription,
      isRecurring: isRecurring ? 1 : 0,
      recurrenceDays: isRecurring ? recurrenceDays.join('') : null,
      recurrenceType: recurrenceTypeValue,
      recurrenceEndDate: recurrenceTypeValue === 2 ? convertToTimestamp(recurrenceEndDate) : null,
    };

    createLeaveInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      this.getLeaveInfo();
    });
  }

  updateLeaveInfo = (values: any) => {
    const { leaveInfo } = this.state;
    const { userAccountId, leaveId, parentLeaveId } = leaveInfo;
    const {
      date,
      leaveType,
      leaveDescription,
      recurrenceDays,
      recurrenceType,
      recurrenceEndDate,
      updateType,
    } = values;
    const isRecurring = recurrenceDays.length > 0;
    const recurrenceTypeValue = isRecurring ? recurrenceType : null;
    const params = {
      startTime: convertToTimestamp10(date[0]),
      endTime: convertToTimestamp10(date[1]),
      leaveType,
      userAccountId,
      leaveId,
      leaveDescription,
      isRecurring: isRecurring ? 1 : 0,
      recurrenceDays: isRecurring ? recurrenceDays.join('') : null,
      recurrenceType: recurrenceTypeValue,
      recurrenceEndDate: recurrenceTypeValue === 2 ? convertToTimestamp(recurrenceEndDate) : null,
      updateType: updateType || 2,
      parentId: parentLeaveId,
    };

    if (!hasPermission('LEAVE_SYSTEM_EDIT')) {
      return message.error(this.errorT.NO_PERMISSION);
    }

    updateLeaveInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      this.getLeaveInfo();
    });
  }

  showLeaveInfo = () => {
    const { weekLeaveObject, specialDateArray } = this.state;

    return this.dateArray.map((item: any, index: number) => {
      const formatedDate = moment(item).format(dateTimeFormat3);
      const { isDayVacationDay } = getDayVacationDateParams({ specialDateArray, startDate: item });
      const { isDayMakeUpDay } = getDayMakeUpDateParams({ specialDateArray, startDate: item });
      const isMakeUp = isDayMakeUpDay ? '(補班)' : '';
      const isVacation = isDayVacationDay ? '(補假)' : '';
      const todayLeaveArray = weekLeaveObject[index];
      const sortedTodayLeaveArray = sortBy(todayLeaveArray, (todayItem) => getMoment(todayItem.startTime).format(timeHrMin));

      return (
        <Col key={index}>
          <Card
            title={
              <>
                <Text>{formatedDate} ({translateDay(index - 1)})</Text>
                {isMakeUp && <Text type="danger">{isMakeUp}</Text>}
                {isVacation && <Text type="success">{isVacation}</Text>}
              </>
            }
            bordered={false}
            headStyle={{ textAlign: 'center' as 'center' }}
          >
            {sortedTodayLeaveArray.map((data: any, weekIndex: number) => {
              const { nameEn, className, startTime, endTime, leaveType } = data;
              return (
                <Tooltip
                  title={
                    <>
                      <div className="leave-div-time">{`${this.leaveT.START}: ${moment(startTime).format(announcementTime)}`}</div>
                      <div className="leave-div-time">{`${this.leaveT.END}: ${moment(endTime).format(announcementTime)}`}</div>
                    </>
                  }
                  key={`leave-data-${weekIndex}`}
                >
                  <div className={`leave-div ${leaveType}`} onClick={() => this.clickEdit(data)}>
                    <div>{className}</div>
                    <div>{nameEn}</div>
                    {hasPermission('LEAVE_SYSTEM_DELETE') &&
                      <div className="leave-div-cancel" onClick={this.clickDelete(data)}>
                        <Badge count={'X'} />
                      </div>
                    }
                  </div>
                </Tooltip>
              );
            })}
          </Card>
        </Col>
      );
    });
  }

  render() {
    const { isModalVisible, leaveInfo, handleType, allStudent, intervalArray } = this.state;
    const okFunction = {
      create: this.createLeaveInfo,
      update: this.updateLeaveInfo,
    };

    return (
      <>
        <Row justify="center" className="leave-search-bar">
          <Col span={24}>
            <div className="leave-type-example-container">
              <div className="leave-type-example">
                <div className="leave-type-example-color sick" />
                <div className="leave-type-example-text">{this.leaveT.SICK}</div>
              </div>
              <div className="leave-type-example">
                <div className="leave-type-example-color personal" />
                <div className="leave-type-example-text">{this.leaveT.PERSONAL}</div>
              </div>
              <div className="leave-type-example other">
                <div className="leave-type-example-color other" />
                <div className="leave-type-example-text">{this.leaveT.OTHER}</div>
              </div>
            </div>
            <div className="re-button-container-right">
              {hasPermission('LEAVE_SYSTEM_NEW') &&
                <ReButton onClick={() => this.clickCreate()}>{this.leaveT.NEW_LEAVE}</ReButton>
              }
              <ReButton onClick={() => this.changeWeekPoint(-1)}>{this.leaveT.LAST_WEEK}</ReButton>
              <ReButton onClick={() => this.changeWeekPoint(1)}>{this.leaveT.NEXT_WEEK}</ReButton>
            </div>
          </Col>
        </Row>
        <Row wrap={false} className="leave-card-container">
          {this.showLeaveInfo()}
        </Row>

        {isModalVisible &&
          <ReModal
            title={this.leaveT.LEAVE_TICKET}
            onCancel={() => this.toggleModal()}
            visible={isModalVisible}
            onOk={(data: any) => getOnOkFunction(handleType, data, okFunction)}
            CollectedForm={ModalLeave}
            formProps={{
              leaveInfo,
              handleType,
              allStudent,
              intervalArray,
            }}
            width={'700px'}
          />
        }
      </>
    );
  }
}

export default LeaveSystem;